export default __webpack_public_path__ + "static/media/Bannersweb_buenfin_medico_2_330x330.7d620a4f.png";